module.exports = __webpack_public_path__ + "static/img/advert_2.00ea63d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ShopSharePrinting/advert_2.png
// module id = xXfE
// module chunks = 10